import { render, staticRenderFns } from "./IngestionResults.vue?vue&type=template&id=82e13648"
import script from "./IngestionResults.vue?vue&type=script&lang=js"
export * from "./IngestionResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports